<template>
  <auth-base
    :action="action"
    :formKey="formKey"
    :additionalData="isB2B || singleSignOn ? {} : hiddenData"
    :submitType="'urlencoded'"
    :onSuccess="onSuccess"
    :onError="onError"
    :b2b-content="b2bContent"
    :method="method"
  >
    <template #title>
      <h1>Sign in to platform</h1>
    </template>

    <ez-input
      type="email"
      label="Email address"
      placeholder="admin@example.com"
      :name="isB2B || singleSignOn ? 'email' : 'username'"
      :value="email"
      v-bind:email.sync="email"
      v-on:onChange="email = $event"
      :error="!!errorMessage"
      :formKey="formKey"
    ></ez-input>

    <ez-input
      v-if="!isB2B && !singleSignOn"
      class="mt-12"
      type="password"
      label="Password"
      name="password"
      v-bind:password.sync="password"
      v-on:onChange="password = $event"
      :error="!!errorMessage ? { message: errorMessage } : false"
      :formKey="formKey"
    ></ez-input>

    <ez-button v-if="!isB2B && !singleSignOn" form-type="submit" isFullWidth>Sign in</ez-button>
    <ez-button v-else form-type="submit" isFullWidth>Send sign-in link</ez-button>

    <slot name="resetPassword"></slot>
  </auth-base>
</template>

<script>
import flash from '@/components/ui/FlashMessage';
import EzInput from '@/components/ui/Input';
import EzButton from '@/components/ui/Button';
import AuthBase from './AuthBase.vue';

export default {
  components: {
    AuthBase,
    EzInput,
    EzButton,
  },
  props: {
    action: {
      type: String,
      required: true,
    },
    isB2B: {
      type: Boolean,
      required: false,
      default: false,
    },
    b2bContent: {
      type: Object,
      required: false,
      default: () => {},
    },
    method: {
      type: String,
      required: false,
      default: 'post',
    },
    singleSignOn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      formKey: 'form-login',
      hiddenData: {
        client_id: 'web',
        grant_type: 'password',
      },
    };
  },
  methods: {
    onSuccess(response) {
      this.$emit('loginSuccess', response);
    },
    onError() {
      flash.error({
        title: 'Sign in failed!',
        message: 'There was an error with your E-Mail/Password combination. Please try again.',
      });

      this.$emit('loginError');
    },
  },
  created() {
    if (this.$route.query?.email) this.email = this.$route.query?.email;
  },
};
</script>

<style scoped lang="scss">
:deep() .auth__form h1 {
  margin: 0 0 2rem;
}

@media (max-width: 768px) {
  :deep() .input-group .input-group__input input {
    font-size: 16px;
  }
}
</style>
